module.exports = function(bootstrap) {
	bootstrap.run(['$rootScope', function($rootScope) {
	    $rootScope.sidebar = {};
	}]);
	bootstrap.directive('compile', ["$state", "$location", "services", "session", "$urlRouter", "$urlMatcherFactory", "$compile", function($state, services, session, $location, $urlRouter, $urlMatcherFactory, $compile) {
		return {
			link: function(scope, element, attrs) {
				scope.$watch(function(scope) {
					// watch the 'compile' expression for changes
					return scope.$eval(attrs.compile);
				}, function(value) {
					// when the 'compile' expression changes
					// assign it into the current DOM
					element.html(value);

					// compile the new DOM and link it to the current
					// scope.
					// NOTE: we only compile .childNodes so that
					// we don't get into infinite loop compiling ourselves
					$compile(element.contents())(scope);
				});
			}
		};
	}]);
	bootstrap.directive('sidebar', ["$state", "services", "session", "$location", "$urlRouter", "$urlMatcherFactory", "$compile", "$q", "$window", '$cookies', function($state, services, session, $location, $urlRouter, $urlMatcherFactory, $compile, $q, $window, $cookies) {
		return {
			replace: true,
			link: function(scope, element) {
				var links = element.find('nav');

				var linkFromState = function(state) {
					for (z in scope.sidebar.links) {
						if (scope.sidebar.links[z].state === state) {
							return scope.sidebar.links[z];
						}
					}
				};
				var setActive = function(link) {
					if (link) {
						link.active = true;
						scope.sidebar.heading = link.heading;
						scope.sidebar.description = link.description;
						scope.sidebar.selectedLink = link.label;
						scope.sidebar.current = link;
					}
					return link;
				};
				scope.handleHref = function(link) {
					if (link.href) {
						return link.deferredHref || $q.when(link.href).then(function(v) {
							link.deferredHref = v;
						});
					}
				};
				scope.toggleLinks = function() {
					if (!links.hasClass('ng-animate')) {
						scope.linksopen = !scope.linksopen;
					}
				};
				scope.toggleRefine = function(link, evt){
					evt.preventDefault();
					link.showRefine = !link.showRefine;

				};

				scope.redirect = function(link, evt) {
                   if (link.onClick) {
                       link.onClick(evt);
                   }
                   scope.linksopen = false;
                   var buttonDefault = element.find('ul>li>a>button');
                   if(evt.target == buttonDefault[0]){
                       evt.preventDefault();
                   }
                   if($.contains(buttonDefault[0], evt.target)){
                       evt.preventDefault();
                   }
				};

				var link = linkFromState($state.current.name);
				if (link) {
					setActive(link);
				}
				else {
					// No link found.  Select 1st link.  This needs changed later to be an option rather than the default behaviour
					setActive(scope.sidebar.links && scope.sidebar.links[0]);
				}
				var initLinks = function(event, toState, toParams, fromState, fromParams) {
					for (z in scope.sidebar.links) {
						scope.sidebar.links[z].active = false;
						var ww = $window.innerWidth || $($window).width();
						if (ww > 1243) { // Desktop
							scope.sidebar.links[z].showRefine = true;
						}
						else if (ww <= 1243 && ww > 935) { // Notebook
							scope.sidebar.links[z].showRefine = true;
						}
						else if (ww <= 935 && ww > 627) { // Tablet
							scope.sidebar.links[z].showRefine = false;
						}
						else if (ww <= 627) { // Mobile
							scope.sidebar.links[z].showRefine = false;
						}
						scope.sidebar.links[z].showRefine = (typeof scope.sidebar.links[z].refineOverrideOpen !== "undefined") ? scope.sidebar.links[z].refineOverrideOpen : scope.sidebar.links[z].showRefine;
					}
					var foundLink = linkFromState($state.current.name) || scope.sidebar.links && scope.sidebar.links[0];
					if (foundLink) {
						setActive(foundLink);
					}
				};
				scope.$watchCollection('sidebar.links', initLinks);
				scope.$on('$stateChangeSuccess', initLinks);
			},
			template: require('articles/sidebar.html')
		}
	}])
}